module.exports = __webpack_public_path__ + "static/img/20015 (2).d6d8010.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20015 (2).webp
// module id = qrVf
// module chunks = 14